import React from 'react';
import {Grid, Label, Button, Modal, Input} from 'semantic-ui-react';
import _ from 'lodash'
import {socket} from "../../lib/socketio";
import { useSelector } from 'react-redux';
import {isAuthorized } from '../../lib/authorization';
import { createUserLog } from '../../lib/api';

const PCSColumn = ({ index, column, data, width, option }) => {

    const [tagdata, setTagdata]= React.useState('');
    const [booldata, setBooldata]= React.useState('');
    const [open,setOpen]= React.useState(false);
    var label1 = 'ENABLE', label2 = 'DISABLE';
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const user = useSelector(state => state.nav.user);
    const [log, setLog]= React.useState('');

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setOpen({...open, [id]:false});
    };

    const handleOption = (e, {id}) => {
        if(id === 1){
            setBooldata('1');
        }
        else if(id === 2){
            setBooldata('0');
        }
    };

    const handleToggle =(event, id, display_id) => {
        event.preventDefault();
        if(typeof booldata === 'undefined' || booldata === ''){
            setOpen({...open, [id]:false});
        }
        else{
            var writeBoolData = [{'tag_id':id, 'tag_value': booldata}];
            socket.emit('write tag', writeBoolData);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [id] }),
                };
                createUserLog({ log }).catch(console.error);
            }
        }
        setBooldata('');
    }

    const getColor = (parm) => {
        if(option === 2) {
            if(parm === 0) {
                return 'green';
            }
            else {
                return 'red';
            }
        }
        else {
            if (parm === 0) {
                return 'red';
            } else {
                return 'green';
            }
        }
    };

    const getValue = (parm, name) => {
        if(name === 'BREAKER') {
            label1 = 'ON';
            label2 = 'OFF';
            if (parm === 0) {
                return 'OFF';
            } else {
                return 'ON';
            }
        }
        else if(name === 'LS_SYNC') {
            label1 = 'SYNC';
            label2 = 'DISABLE';
            if (parm === 0) {
                return 'DISABLE';
            }
            else if(parm === 1){
                return 'SYNC';
            }
        }
        else {
            label1 = 'ENABLE';
            label2 = 'DISABLE';
            if (parm === 0) {
                return 'DISABLE';
            }
            else if(parm === 1){
                return 'ENABLE';
            }
            else {
                return parm;
            }
        }
    }

    const handleSubmit = (event, value, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setTagdata('');
    }

    const handleChange = (event, value, id, display_id) => {
        event.preventDefault();
        setTagdata(event.target.value);
        if(!electronApp){
            setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [id]}) })
        }
    }

    const gridColumn = _.times((1), (i) => (
        <Grid key = {index} stackable style={styles.grid}>
            {/*<p style={{textAlign: 'center'}}>{column[i].tag_display_subgroup}</p>*/}
            <p style={{color: '#fff', fontWeight: 'bold', marginLeft : '10px'}}>{column[i].tag_display_subgroup}</p>
            {column[i].tag_display_subgroup === 'PCS TO PPC ANALOG WORDS' || column[i].tag_display_subgroup === 'PCS COMMANDS'  ?
                column.map(r =>
                    r.tag_display_name === 'STOP SWITCH RECOVERY' ?
                        <Grid.Row key = {r.id} style={styles.row}>
                            <Grid.Column width='10' style={{color: '#00C0C0', fontWeight: 'bold'}}>{r.tag_display_name} </Grid.Column>
                            <Grid.Column width = '6'> {getValue(data[r.id], r.tag_display_name.slice(-7))} </Grid.Column>
                        </Grid.Row>
                        :
                        <Grid.Row key = {r.id} style={styles.row}>
                            <Grid.Column width='10' style={{color: '#00C0C0', fontWeight: 'bold'}}>{r.tag_display_name} </Grid.Column>
                            <Grid.Column width = '6'> {data[r.id]} </Grid.Column>
                        </Grid.Row>
                )
                :
                column[i].tag_display_subgroup === 'PPC TO PCS MULS CONTROL WORD' || column[i].tag_display_subgroup === 'PPC TO PCS OVERRIDES' ?
                    column.map(r =>
                        <Grid.Row key = {r.id} style={styles.row}>
                            <Grid.Column width='10' style={{color: '#00C0C0', fontWeight: 'bold'}}>{r.tag_display_name} </Grid.Column>
                            <Grid.Column width = '6'>
                                {r.name.slice(-3) === 'OVR' || r.name.slice(-5) === 'DELTA' ?
                                    <>
                                        <Button
                                            key = 'button'
                                            type = 'button'
                                            color = 'blue'
                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                            content = {data[r.id]}
                                            onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                        <Modal
                                            key = {r.id}
                                            style = {styles.width}
                                            open = {open[r.id]}
                                            onClose={handleClose[r.id]}
                                            onOpen={handleOpen[r.id]}>
                                            <Modal.Header>{r.tag_display_name}</Modal.Header>
                                            <Modal.Content>
                                                <form  style = {styles.form} autoComplete='off' onSubmit={(event, value) => handleSubmit(event, value, r.id, r.min, r.max)}>
                                                    <Input focus autoFocus placeholder='Value'
                                                           name='Input change'
                                                           label = {r.unit || ""}
                                                           labelPosition='right'
                                                           type='number'
                                                           step ='0.001'
                                                           size='small'
                                                           min ={r.min}
                                                           max ={r.max}
                                                           onChange={(event, value) => handleChange(event, value, r.id, r.display_id)}
                                                           defaultValue={data[r.id]}
                                                    />
                                                </form>
                                                <Button
                                                    key = 'button'
                                                    content = 'Close'
                                                    color = 'red'
                                                    style={{marginLeft: '5px', marginTop: '10px'}}
                                                    onClick ={  () => {setOpen({...open, [r.id]:false})}}/>
                                            </Modal.Content>
                                        </Modal>
                                    </>
                                    :
                                    column[i].tag_display_subgroup === 'CALCULATED PARAMETERS' ?
                                        ''
                                    :
                                    <>
                                        <Button
                                            key = 'button'
                                            type = 'button'
                                            content = {getValue(data[r.id], r.name.slice(-7))}
                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                            color = 'blue'
                                            onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                        <Modal
                                            key = {r.id}
                                            style = {styles.width}
                                            open = {open[r.id]}
                                            onClose={handleClose[r.id]}
                                            onOpen={handleOpen[r.id]}>
                                            <Modal.Header>{r.tag_display_name} </Modal.Header>
                                            <Modal.Content>
                                                <Input
                                                    type = 'checkbox'
                                                    id = {1}
                                                    label = {label1}
                                                    onChange={handleOption}
                                                    style = {styles.checkbox}
                                                />
                                                <Input
                                                    type = 'checkbox'
                                                    id = {2}
                                                    label = {label2}
                                                    onChange={handleOption}
                                                    style = {styles.checkbox}
                                                />
                                            </Modal.Content>
                                            <Modal.Actions style = {styles.toggle}>
                                                <Button color='blue' content={'Ok'} onClick={(event, value) => handleToggle(event,r.id, r.display_id)}/>
                                                <Button color='red' content={'Cancel'} onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                            </Modal.Actions>
                                        </Modal>
                                    </>

                                }
                            </Grid.Column>
                        </Grid.Row>
                    )
                    :
                    column.map(r =>
                        r.name === 'AINPCS_GRIDSTATUSWORD1_VALUE' || r.tag_display_subgroup === 'PCS_CHECKOUT_MODE' ?
                            <>
                            </>
                            : r.hmi_controlloop_subdisplay === 'ANALOG'? 
                                <Grid.Row key = {r.id} style={styles.row}> {/**PCS Warning & Fault 코드  */}
                                    <Grid.Column width='13' style={{color: '#00C0C0', fontWeight: 'bold'}}> {r.tag_display_name}</Grid.Column>
                                    <Grid.Column width='1'>
                                        {(typeof data !== 'undefined' && data !== null &&  data[r.id] !== null && typeof data[r.id] !== 'undefined' && !isNaN(data[r.id])) ? ((r.datatype !== 'Boolean') ? data[r.id].toFixed(2) : data[r.id]) : ''}
                                    </Grid.Column>
                                </Grid.Row>
                            :
                            <Grid.Row key = {r.id} style={styles.row}> {/**PCS Warning & Fault 코드  */}
                                <Grid.Column width='13' style={{color: '#00C0C0', fontWeight: 'bold'}}> {r.tag_display_name}</Grid.Column>
                                <Grid.Column width='1'>
                                    <Label circular horizontal empty size='large' color={getColor(data[r.id])}/>
                                </Grid.Column>
                            </Grid.Row>
                    )
            }
        </Grid>
    ))

    return (
        column[0].tag_display_subgroup === 'CALCULATED PARAMETERS' ||  column[0].tag_display_subgroup === 'PCS_APCCRSWORD' || column[0].tag_display_subgroup === 'PCS_CHECKOUT_MODE' ?
            ''
            :
            <Grid.Column key={index} style={{maxWidth: width, padding: '0'}}>
                {gridColumn}
            </Grid.Column>
    );
};

const styles = {
    grid: {
        // margin: '0',
        marginBottom: '0px',
        marginTop: '0px',
        paddingBottom: '0px',
        paddingTop: '0px'
    },
    row: {
        padding: '2px 5px',
        // paddingTop: '0px',
        // paddingBottom: '4px',
        flex: '0 0 90%',
        marginLeft : '5px'
        },
    name: {
        color: 'yellow',
        padding: '2px 0',
        marginBottom: '3%',
        marginRight: '3%'
    },
    header: {
        marginBottom: '15px',
        textAlign: 'center'
    },
    metadata: {
        maxWidth: '300px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginLeft: '10px'
    },
    width: {
        width: '300px'
    },
    wrap: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    }
};

export default React.memo(PCSColumn);
